import { IExtendedContext } from '../../../types/extendedContext';
import { setOffer } from '../../../../shared/ServicePickerWidget/actions/offer';
import { IOfferState } from '../../../../shared/ServicePickerWidget/types/reducers/offer';

export const setOfferHandler = (context: IExtendedContext) => (offer: Partial<IOfferState>) => {
  context.store.dispatch(setOffer(offer));

  return true;
};
